import { Home, Search as SearchIcon, Calendar, User, Settings, Building2, Users, Mail, MessageSquare, Calculator, Phone, FileText, Shield, HelpCircle, Star, CheckCircle } from "lucide-react";

import Index from "./pages/Index";
import Search from "./pages/Search";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ForBusiness from "./pages/ForBusiness";
import ForBusinessV2 from "./pages/ForBusinessV2";
import Pricing from "./pages/Pricing";
import TermsOfService from "./pages/TermsOfService";
import Privacy from "./pages/Privacy";
import Support from "./pages/Support";
import Auth from "./pages/Auth";
import Booking from "./pages/Booking";
import BookingDetails from "./pages/BookingDetails";
import BookingSuccess from "./pages/BookingSuccess";
import PaymentSuccess from "./pages/PaymentSuccess";
import ProfileCompletion from "./pages/ProfileCompletion";
import ProviderProfile from "./pages/ProviderProfile";
import ProviderDashboard from "./pages/ProviderDashboard";
import ProviderBookingDetail from "./pages/ProviderBookingDetail";
import ProviderBookingDetailTest from "./pages/ProviderBookingDetailTest";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";
import RevenueCalculator from "./pages/RevenueCalculator";
import WindowSticker from "./pages/WindowSticker";
import AccessControl from "./pages/AccessControl";
import Debug from "./pages/Debug";
import AppHome from "./pages/app/AppHome";
import AppBook from "./pages/app/AppBook";
import AppBookingFlow from "./pages/app/AppBookingFlow";
import AppBookings from "./pages/app/AppBookings";
import AppProfile from "./pages/app/AppProfile";
import AppAuth from "./pages/app/AppAuth";
import AppBookingDetails from "./pages/app/AppBookingDetails";
import AppAccountSettings from "./pages/app/AppAccountSettings";
import AppEmergencyContact from "./pages/app/AppEmergencyContact";
import AppChangePassword from "./pages/app/AppChangePassword";
import AppMemberships from "./pages/app/AppMemberships";
import AppCoupons from "./pages/app/AppCoupons";
import AppSupport from "./pages/app/AppSupport";
import AppSplash from "./pages/app/AppSplash";
import RedirectRoute from "./components/RedirectRoute";

export interface NavItem {
  title: string;
  to: string;
  icon?: React.ReactNode;
  page: React.ReactNode;
  restricted?: boolean;
}

export const navItems: NavItem[] = [
  {
    title: "Home",
    to: "/",
    icon: <Home className="h-4 w-4" />,
    page: <Index />,
  },
  {
    title: "Search",
    to: "/search",
    icon: <SearchIcon className="h-4 w-4" />,
    page: <Search />,
  },
  {
    title: "Dashboard",
    to: "/dashboard",
    icon: <User className="h-4 w-4" />,
    page: <Dashboard />,
  },
  {
    title: "Profile",
    to: "/profile",
    icon: <Settings className="h-4 w-4" />,
    page: <Profile />,
  },
  {
    title: "About",
    to: "/about",
    icon: <Building2 className="h-4 w-4" />,
    page: <About />,
  },
  {
    title: "Contact",
    to: "/contact",
    icon: <Mail className="h-4 w-4" />,
    page: <Contact />,
  },
  {
    title: "For Business",
    to: "/for-business",
    icon: <Users className="h-4 w-4" />,
    page: <ForBusiness />,
  },
  {
    title: "For Business V2",
    to: "/for-business-v2",
    icon: <Users className="h-4 w-4" />,
    page: <ForBusinessV2 />,
  },
  {
    title: "Pricing",
    to: "/pricing",
    icon: <Calculator className="h-4 w-4" />,
    page: <Pricing />,
  },
  {
    title: "Terms of Service",
    to: "/terms",
    icon: <FileText className="h-4 w-4" />,
    page: <TermsOfService />,
  },
  {
    title: "Privacy Policy",
    to: "/privacy",
    icon: <Shield className="h-4 w-4" />,
    page: <Privacy />,
  },
  {
    title: "Support",
    to: "/support",
    icon: <HelpCircle className="h-4 w-4" />,
    page: <Support />,
  },
  {
    title: "Auth",
    to: "/auth",
    icon: <User className="h-4 w-4" />,
    page: <Auth />,
  },
  {
    title: "Booking",
    to: "/booking/:providerId/:serviceId",
    icon: <Calendar className="h-4 w-4" />,
    page: <Booking />,
  },
  {
    title: "Booking Details",
    to: "/booking-details/:bookingId",
    icon: <Calendar className="h-4 w-4" />,
    page: <BookingDetails />,
  },
  {
    title: "Booking Success",
    to: "/booking-success",
    icon: <CheckCircle className="h-4 w-4" />,
    page: <BookingSuccess />,
  },
  {
    title: "Profile Completion",
    to: "/profile-completion",
    icon: <User className="h-4 w-4" />,
    page: <ProfileCompletion />,
  },
  {
    title: "Provider Profile (by slug)",
    to: "/provider/:slug",
    icon: <Building2 className="h-4 w-4" />,
    page: <ProviderProfile />,
  },
  {
    title: "Provider Profile with Service",
    to: "/provider/:slug/:serviceId",
    icon: <Building2 className="h-4 w-4" />,
    page: <ProviderProfile />,
  },
  {
    title: "Provider Profile",
    to: "/provider-profile/:providerId",
    icon: <Building2 className="h-4 w-4" />,
    page: <ProviderProfile />,
  },
  {
    title: "Management",
    to: "/management",
    icon: <Home className="h-4 w-4" />,
    page: <ProviderDashboard />,
    restricted: true,
  },
  {
    title: "Provider Dashboard",
    to: "/management/dashboard",
    icon: <Home className="h-4 w-4" />,
    page: <ProviderDashboard />,
    restricted: true,
  },
  {
    title: "Provider Booking Detail",
    to: "/management/booking/:bookingId",
    icon: <Calendar className="h-4 w-4" />,
    page: <ProviderBookingDetail />,
    restricted: true,
  },
  {
    title: "Provider Booking Detail Test",
    to: "/provider-booking-test",
    icon: <Calendar className="h-4 w-4" />,
    page: <ProviderBookingDetailTest />,
    restricted: true,
  },
  {
    title: "Legacy Booking Detail Redirect",
    to: "/management/booking/id/:bookingId",
    icon: <Calendar className="h-4 w-4" />,
    page: <RedirectRoute />,
    restricted: true,
  },
  {
    title: "Admin",
    to: "/admin",
    icon: <Settings className="h-4 w-4" />,
    page: <Admin />,
  },
  {
    title: "Not Found",
    to: "/404",
    icon: <HelpCircle className="h-4 w-4" />,
    page: <NotFound />,
  },
  {
    title: "Revenue Calculator",
    to: "/revenue-calculator",
    icon: <Calculator className="h-4 w-4" />,
    page: <RevenueCalculator />,
  },
  {
    title: "Window Sticker",
    to: "/window-sticker",
    icon: <Star className="h-4 w-4" />,
    page: <WindowSticker />,
  },
  {
    title: "Access Control",
    to: "/access-control",
    icon: <Shield className="h-4 w-4" />,
    page: <AccessControl />,
  },
  {
    title: "Debug",
    to: "/debug",
    icon: <HelpCircle className="h-4 w-4" />,
    page: <Debug />,
  },
  {
    title: "Payment Success",
    to: "/payment-success",
    icon: <CheckCircle className="h-4 w-4" />,
    page: <PaymentSuccess />,
  },
  {
    title: "App Home",
    to: "/app",
    icon: <Home className="h-4 w-4" />,
    page: <AppHome />,
  },
  {
    title: "App Book",
    to: "/app/book",
    icon: <Calendar className="h-4 w-4" />,
    page: <AppBook />,
  },
  {
    title: "App Booking Flow",
    to: "/app/book/:providerId/:serviceId",
    icon: <Calendar className="h-4 w-4" />,
    page: <AppBookingFlow />,
  },
  {
    title: "App Bookings",
    to: "/app/bookings",
    icon: <Calendar className="h-4 w-4" />,
    page: <AppBookings />,
  },
  {
    title: "App Profile",
    to: "/app/profile",
    icon: <User className="h-4 w-4" />,
    page: <AppProfile />,
  },
  {
    title: "App Auth",
    to: "/app/auth",
    icon: <User className="h-4 w-4" />,
    page: <AppAuth />,
  },
  {
    title: "App Booking Details",
    to: "/app/booking/:bookingId",
    icon: <Calendar className="h-4 w-4" />,
    page: <AppBookingDetails />,
  },
  {
    title: "App Account Settings",
    to: "/app/account",
    icon: <Settings className="h-4 w-4" />,
    page: <AppAccountSettings />,
  },
  {
    title: "App Emergency Contact",
    to: "/app/emergency-contact",
    icon: <Shield className="h-4 w-4" />,
    page: <AppEmergencyContact />,
  },
  {
    title: "App Change Password",
    to: "/app/change-password",
    icon: <Shield className="h-4 w-4" />,
    page: <AppChangePassword />,
  },
  {
    title: "App Memberships",
    to: "/app/memberships",
    icon: <Star className="h-4 w-4" />,
    page: <AppMemberships />,
  },
  {
    title: "App Coupons",
    to: "/app/coupons",
    icon: <Star className="h-4 w-4" />,
    page: <AppCoupons />,
  },
  {
    title: "App Support",
    to: "/app/support",
    icon: <HelpCircle className="h-4 w-4" />,
    page: <AppSupport />,
  },
  {
    title: "App Splash",
    to: "/app/splash",
    icon: <Star className="h-4 w-4" />,
    page: <AppSplash />,
  },
];
